import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import AppRoutes from './routes/AppRoutes';

function App() {
  // FCM token is now requested ONLY after login (in SignIn.js)
  // This ensures each user gets their own unique token

  return (
    <Router>
      <div className="App" style={{ margin: 0, padding: 0 }}>
        <Toaster position="top-right" />
        <AppRoutes />
      </div>
    </Router>
  );

  
  
}

export default App;